import { render, staticRenderFns } from "./qyxxbgLook2.vue?vue&type=template&id=61d83aca&scoped=true&"
import script from "./qyxxbgLook2.vue?vue&type=script&lang=js&"
export * from "./qyxxbgLook2.vue?vue&type=script&lang=js&"
import style0 from "./qyxxbgLook2.vue?vue&type=style&index=0&id=61d83aca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d83aca",
  null
  
)

export default component.exports